import { OptionHint as e, OptionLabel as t, OptionList as n, OptionRow as r } from "../styled/TimeOptionList.styled.mjs";
import { useEffect as i, useRef as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { formatTimePicker as c } from "@maat/datetime";
//#region src/components/TimePicker/components/TimeOptionList.tsx
var l = 1440, u = 480, d = (e) => {
	let [t, n] = e.split(":").map(Number);
	return (Number.isFinite(t) ? t : 0) * 60 + (Number.isFinite(n) ? n : 0);
}, f = (e) => `${String(Math.floor(e / 60)).padStart(2, "0")}:${String(e % 60).padStart(2, "0")}`, p = ({ value: p, step: m, options: h, onPick: g }) => {
	let { taken: _ = [], onTaken: v, hint: y, from: b = "00:00" } = h, x = a(null), S = a(null), C = m > 0 ? m : 5, w = new Set(_), T = [];
	for (let e = d(b); e < l; e += C) T.push(f(e));
	let E = (p && T.includes(p) ? p : void 0) ?? T.find((e) => !w.has(e) && d(e) >= u) ?? T.find((e) => !w.has(e));
	return i(() => {
		let e = x.current, t = S.current;
		!e || !t || (e.scrollTop = Math.max(0, t.offsetTop - e.clientHeight / 2 + t.offsetHeight / 2));
	}, [E]), /* @__PURE__ */ o(n, {
		ref: x,
		role: "listbox",
		tabIndex: -1,
		children: T.map((n) => {
			let i = w.has(n), a = !!p && p === n, l = y?.(n);
			return /* @__PURE__ */ s(r, {
				ref: n === E ? S : void 0,
				type: "button",
				role: "option",
				"aria-selected": a,
				"aria-disabled": i || void 0,
				$sel: a,
				$taken: i,
				onClick: () => i ? v?.(n) : g(n),
				children: [/* @__PURE__ */ o(t, {
					$sel: a,
					$taken: i,
					children: c(n)
				}), l && /* @__PURE__ */ o(e, {
					$sel: a,
					children: l
				})]
			}, n);
		})
	});
};
//#endregion
export { p as TimeOptionList };
